<script setup lang="ts">
import BaseLayout from "@/layouts/BaseLayout.vue";
import {computed, ref} from "vue";
import {useAuth} from "@/composables/auth";
import {useColors} from "@/composables/colors";
import {useDate} from "@/composables/date";
import {router} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import {AssessmentSummary, Pagination} from "@/types";
import {DataTableHeader} from "vuetify/framework";
import IconTooltip from "@/components/tooltips/IconTooltip.vue";
import CompletedChip from "@/components/chips/CompletedChip.vue";
import ClosedChip from "@/components/chips/ClosedChip.vue";
import OpenChip from "@/components/chips/OpenChip.vue";
import IconDateTooltip from "@/components/tooltips/IconDateTooltip.vue";
import DueDateTooltip from "@/components/tooltips/DueDateTooltip.vue";
import {useNumber} from "@/composables/number";
import TitleAvatar from "@/components/avatars/TitleAvatar.vue";

defineOptions({layout: BaseLayout})

</script>

<template>
    <v-container>
        <v-sheet>
            <h1>About</h1>
            <p class="text-body-1 mt-4">
                This resource is supported as a whole or in part by the National Institute Of Allergy And Infectious Diseases of the National Institutes of Health under grant n°<a
                    href="https://reporter.nih.gov/search/JHbtQB-XeUu8wvs3vUlFFw/project-details/10913643?utm_source=capacity_framework_portal"
                    target="_blank"
                    class="custom-link px-1 text-decoration-none text-primary"
                >U24AI183840</a> - <a
                    href="https://pathogendatanetwork.org?utm_source=capacity_framework_portal"
                    target="_blank"
                    class="custom-link px-1 text-decoration-none text-primary"
                >Pathogen Data Network</a>.
            </p>
        </v-sheet>
    </v-container>
</template>

<style scoped>
</style>
